import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const TermnCon = () => {
  return (
    <div className="termconditionbody">
      <Navbar />
      <div className="termNCon">
        <h1>Terms and Conditions</h1>
        <p>
          Tron Healthcare Private Limited is an offering in India that promotes
          overall wellness by bringing awareness among the people on the
          importance of preventive healthcare and its impact on quality of life.
          These products are not insurance products or insurance offerings.
          TronHC promotes preventive health and aims to make available OPD
          health care at affordable cost by subsidising the treatment costs and
          offering discounted preventive and curative health packages.
          <br />
          <br />
          The preferred provider network of TronHC includes third party clinics
          and hospitals of repute and having met the quality standards of TronHC
          and have agreed to perform the treatments at a particular cost and
          quality.
          <br />
          <br />
          TronHC has a Quality Audit Committee that audits the clinics and
          hospitals in terms of quality of infrastructure, processes and
          treatment care. TronHC does not own any of these clinics and hospitals
          or is the direct financial beneficiary of any treatments undertaken.
          <br />
          <br />
          TronHC shall not be liable for any negligence or misconduct of the
          providers. TronHC on its best effort basis endeavours to ensure that
          the doctors engaged by TronHC are doing so for a societal cause and in
          case any unethical practice is suspected against the practitioner,
          TronHC disciplinary committee will de-empanel such a service provider
          from TronHC’s network.
          <br />
          <br />
          TronHC allots the subscriber to a clinic without bias based on the
          preference of the subscriber. TronHC does not hold any reservations
          for or against any practitioner. It offers the service provider’s
          details to relevant members only on the basis of the need and
          convenience of the member. <br />
          <br />
          TronHC reserves a right to de-empanel doctors in case they fail to
          adhere to the pricing norms or materially fail to carry out any of
          their obligations.
          <br />
          <br />
          TronHC is entitled to use the data of the subscribers for any research
          or epidemiological purposes. TronHC appreciates feedback from its
          members (via feedback section and contact us section of this website)
          and ensures resolution to all fair requests and does not encourage the
          use of any public media/ forum with respect to any issues with the
          services offered to its members
        </p>
        <br />
        <br />
        <h1>Product Pricing Disclamer</h1>
        <ul>
          <li>
            Pricing for plans and packages listed on the website are current.
            While every care has been taken to label service products
            accurately, errors in the data entry and/or updating may occur.{" "}
          </li>
          <li>
            TronHC reserves the right to cancel any plan or package in such a
            case where a transaction has already been made and the price
            indicated was incorrect.{" "}
          </li>
          {/* <li>
            In the aforementioned rare event, a full refund of the payment
            received from the customer shall be processed with accuracy.{" "}
          </li> */}
          <li>
            All prices on this website are in Indian Rupees only, usage of
            international cards on the site may prompt the respective bank's
            applicable exchange rate and charges.{" "}
          </li>
          <li>
            We have no jurisdiction on the same and/or any disputes/queries
            arising due to exchange rates and/or bank charges. The queries need
            to be directed towards the bank or institution that issued the said
            card or payment instrument.{" "}
          </li>
          <li>
            We have no jurisdiction on the same and/or any disputes/queries
            arising due to exchange rates and/or bank charges. The queries need
            to be directed towards the bank or institution that issued the said
            card or payment instrument.{" "}
          </li>
          <li>Prices are subject to change without advance notice.</li>
          <li>Our products are liable for GST in India.</li>
          <li style={{ listStyleType: "none", marginTop: "5px" }}>
            <h3 style={{ color: "#faf0ca" }}>Refund Policy</h3>
            <p style={{ marginTop: "5px" }}>
              Refunds within 7 days of buying a plan prior to using any services
              of Tron may be considered for refund if validated with a genuine
              reason. Group plans once bought cannot be refunded at all.
            </p>
            <p style={{ marginTop: "5px" }}>
              Refund requests will be processed in 7 days and the refund amount
              will reflect in customer's account in 14 days.
            </p>
          </li>
        </ul>
        <br />
        <br />
        <h1>Disclamer</h1>
        <p>
          Contents of this website are for general information or use only. They
          do not constitute advice and should not be relied upon in making (or
          refraining from making) any decision. Tron Healthcare Private Limited
          hereby excludes any warranty, express or implied, as to quality,
          accuracy, timeliness, completeness, performance, fitness for a
          particular purpose of the site or any of its contents, including (but
          not limited) to any financial tools contained within the site.
          <br />
          <br />
          Tron Healthcare Private Limited shall not be liable for any damages
          (including, without limitation, damages for loss of business projects,
          or loss of profits) arising in contract, tort or otherwise from the
          use of or inability to use the website or any of its contents, or from
          any action taken (or refrained from being taken) as a result of using
          the site or any such contents. <br />
          <br />
          Tron Healthcare Private Limited makes no warranty that the contents of
          the site are free from any infection by viruses or anything else which
          has contaminating or destructive properties. No information on this
          site shall constitute an invitation to invest in Tron Healthcare
          Private Limited or any of its affiliates. Neither Tron Healthcare
          Private Limited and its affiliates nor their or their affiliates
          officers, employees or agents shall be liable for any loss, damage or
          expense arising out of any access to or use of this site or any site
          linked to it, including, without limitation, any loss of profit,
          indirect, incidental or consequential loss. <br />
          <br />
          No reproduction of any part of the site may be sold or distributed for
          commercial gain, nor shall it be modified or incorporated in any other
          work, publication or site, whether in hard copy or electronic format,
          including postings to any other site. Also, you may not, without our
          permission, copy and distribute this information on any other server,
          or modify or reuse text or graphics on this or any other system. Tron
          Healthcare Private Limited reserves all other rights.
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default TermnCon;
